import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "auto"]
  static values = { delay: Number }

  connect() {
    this.timeout = null
    this.lastValue = this.inputTarget?.value || ""
    this.isAutoSubmit = false
  }

  queueSubmit() {
    clearTimeout(this.timeout)
    const nextValue = this.inputTarget.value
    this.timeout = setTimeout(() => {
      if (nextValue === this.lastValue) return
      this.lastValue = nextValue
      this.isAutoSubmit = true
      if (this.hasAutoTarget) this.autoTarget.value = "1"
      if (typeof this.element.requestSubmit === "function") {
        this.element.requestSubmit()
      } else {
        this.element.submit()
      }
    }, this.delayValue || 450)
  }

  handleSubmit() {
    if (this.isAutoSubmit) {
      this.isAutoSubmit = false
      return
    }
    if (this.hasAutoTarget) this.autoTarget.value = ""
  }
}
